import {
  HStack,
  IconButton,
  Menu,
  MenuButton,
  MenuDivider,
  MenuGroup,
  MenuItem,
  MenuList,
  Spacer,
  Tooltip,
} from "@chakra-ui/react";
import { TimingState } from "./Post";
import {
  Clock,
  Copy,
  Ghost,
  MenuIcon,
  Pin,
  Trash2,
  Wrench,
} from "lucide-react";

interface ToolbarItem<T> {
  state: T;
  onStateChange: (newState: T) => void;
  onCreationRequest?: () => void;
}

export function Toolbar(props: {
  pin: ToolbarItem<boolean>;
  hide: ToolbarItem<boolean>;
  timing: ToolbarItem<TimingState | undefined>;
  edit: { onAction: () => void };
  copy: { onAction: () => void };
  delete: { onAction: () => void };
}) {
  return (
    <HStack background={"gray.100"}>
      {/* Selected item icons */}
      {props.pin.state && (
        <Tooltip label="Pinned to top">
          <IconButton
            background={"blue.200"}
            aria-label="Unpin"
            onClick={() => {
              props.pin.onStateChange(false);
            }}
            icon={<Pin color="white" />}
          />
        </Tooltip>
      )}
      {props.hide.state && (
        <Tooltip label="Dold">
          <IconButton
            aria-label="Dölj inlägg"
            background={"blue.200"}
            onClick={() => {
              props.hide.onStateChange(false);
            }}
            icon={<Ghost color="white" />}
          />
        </Tooltip>
      )}
      {props.timing.state &&
        props.timing.state.showStartEpoch !== undefined && (
          <Tooltip
            label={`Visas mellan ${dateToString(
              props.timing.state.showStartEpoch
            )} till ${dateToString(props.timing.state.showEndEpoch)}`}
          >
            <IconButton
              aria-label="Sätt visningstid"
              background={"blue.200"}
              icon={<Clock color="white" />}
              onClick={() => props.timing.onStateChange(undefined)}
            />
          </Tooltip>
        )}
      <Spacer />
      {/* Popup menu */}
      <Menu>
        <MenuButton
          as={IconButton}
          aria-label="Options"
          icon={<MenuIcon />}
          variant="outline"
        />
        <MenuList>
          <MenuGroup color="black" title="Visa">
            <MenuItem
              color={"black"}
              onClick={(e) => {
                props.pin.onStateChange(true);
              }}
              icon={<Pin />}
            >
              Visa överst
            </MenuItem>
            <MenuItem
              color={"black"}
              onClick={() => {
                props.timing.onCreationRequest &&
                  props.timing.onCreationRequest();
              }}
              icon={<Clock />}
            >
              Sätt visningstid
            </MenuItem>
            <MenuItem
              color={"black"}
              onClick={() => props.hide.onStateChange(true)}
              icon={<Ghost />}
            >
              Dölj inlägg
            </MenuItem>
          </MenuGroup>
          <MenuDivider />
          <MenuGroup color={"black"} title="Ändra/Skapa">
            <MenuItem
              color={"black"}
              icon={<Wrench />}
              onClick={() => props.edit.onAction()}
            >
              Uppdatera
            </MenuItem>
            <MenuItem
              color={"black"}
              icon={<Copy />}
              onClick={() => props.copy.onAction()}
            >
              Kopiera
            </MenuItem>
            <MenuItem
              color={"black"}
              icon={<Trash2 />}
              onClick={() => {
                const removePost = window.confirm(
                  "Detta val tar bort inlägget permanent. Vill du fortsätta?"
                );
                if (removePost) {
                  props.delete.onAction();
                }
              }}
            >
              Ta bort permanent
            </MenuItem>
          </MenuGroup>
        </MenuList>
      </Menu>
    </HStack>
  );
}

function dateToString(date: Date | undefined) {
  if (date === undefined) {
    return "-";
  } else {
    // 10:00 D/M-yyyy
    return `${date.getDate()}/${date.getMonth()}-${date.getFullYear()}`;
  }
}
